// Keep in sync with transitions.less
export const TRANSITION_FADE_DURATION_MS = 100;
export const TRANSITION_SLIDE_RIGHT_DURATION_MS = 100;
export const TRANSITION_SLIDE_LEFT_DURATION_MS = 800;
export const TRANSITION_APPEAR_TIMEOUT_MS = 1000;

// Keep in sync with sidepanel.less
export const TRANSITION_SLIDE_SIDEPANEL_DURATION_MS = 250;
